export default (form, inputName, validationMessages) => {
  // Иногда, форма ещё не в DOM'е, а создать этот объект валидации хочется сразу же
  const getForm = angular.isFunction(form) ? form : () => form;

  const getValidationMessage = angular.isFunction(validationMessages) ? validationMessages : (key) => validationMessages[key];

  const defaultValidationMessages = {
    parse: 'Значение указано не корректно',
    integer: 'Введите целое число',
    phoneNumberParse: 'Допустимы цифры и знаки ( ) -',
    phoneNumberMask: 'Некорректный формат телефона'
  };

  // Получение серверного сообщения об ошибке
  const getRemoteValidationMessage = (name) => {
    let result = [];

    if (getForm().remoteValidator) {
      result = getForm().remoteValidator.getErrorFieldMessage(name || inputName);
    }

    return result;
  };

  // приоритет клиенсткой валидации над серверной
  const getKey = error => {
    const keys = Object.keys(error);
    return (keys.length > 1 && keys[0] === 'remote') ? keys[1] : keys[0];
  };

  return {
    invalid: (name = inputName) => {
      const form = getForm();

      if (form && form[name]) {
        return form[name].$invalid && (form.$submitted || form[name].$touched);
      }
    },
    message: (name = inputName) => {
      const form = getForm();

      if (form && form[name]) {
        /**
         * TODO не очень хорошее решение с пустой строкой, вылезают баги, надо пофиксить в тултипе самом
         * TODO отправляем пустое значение если пока(уже) текста ошибки нет,
         * TODO для того чтобы коректно работал tooltip.
         */
        const key = getKey(form[name].$error);
        let message = ' ';
        if (key) {
          // remote - серверное сообщение об ошибке поля
          if (key === 'remote') {
            message = getRemoteValidationMessage(name).join(', ') || ' ';
          } else {
            message = getValidationMessage(key) || defaultValidationMessages[key] || ' ';
          }
        }
        return message;
      }
    },
    messages: (name = inputName) => {
      const form = getForm();

      if (form && form[name] && form[name].$invalid) {
        return getRemoteValidationMessage(name) || [];
      }
    },
    clientMessage: (name = inputName) => {
      const form = getForm();

      const key = getKey(form[name].$error);

      if (form && form[name] && form[name].$invalid && key) {
        return getValidationMessage(key) || defaultValidationMessages[key] || '';
      }
    }
  };
};
